<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite certifikat:
    </h2>

    <CertificateForm
      @save="save"
      @cancel="cancel"
      :premiseTypes="premiseTypes"
      :certificate="certificate"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import CertificateForm from '@/components/CertificateForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    CertificateForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    childCompanyId: {
      required: true,
      type: Number
    },
    certificateId: {
      required: true,
      type: Number
    }
  },
  computed: {
    certificate () {
      return this.$store.state.clientsCertificates.items[this.certificateId]
    },
    premiseTypes () {
      return objectToArray(this.$store.state.premiseTypes.items)
    }
  },
  methods: {
    ...mapActions('clientsCertificates', ['loadItem', 'saveItem']),
    ...mapActions('premiseTypes', { loadPremiseTypes: 'loadItems' }),
    save ({ data }) {
      saveItem({ childCompanyId: this.childCompanyId, item: { ...data, id: this.certificateId } }, 'ClientsCertificates', this)
    },
    cancel () {
      this.$router.push({ name: 'ClientsCertificates' })
    }
  },
  created () {
    Promise.all([
      this.loadItem({ childCompanyId: this.childCompanyId, certificateId: this.certificateId }),
      this.loadPremiseTypes()
    ])
      .then(items => { this.asyncDataStatus_fetched() })
  }
}
</script>
